import React from 'react';
import './SeniorAuditor.css';

const CHECKS = [
  { q: 'Was the inspection set up correctly?', ref: 'vs. procedure' },
  { q: 'Was it executed by qualified personnel?', ref: 'vs. certifications' },
  { q: 'Is every detail of the report in spec?', ref: 'vs. specification' },
  { q: 'Does the decision hold against the code?', ref: 'vs. applicable codes' },
];

function Check() {
  return (
    <span className="aqp-sa__check">
      <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="3">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
  );
}

function SeniorAuditor() {
  return (
    <section className="aqp-section aqp-sa" data-screen-label="Senior auditor">
      <div className="aqp-sa__inner">
        <div className="aqp-cols aqp-sa__cols">
          <div className="aqp-sa__copy">
            <span className="aqp-reveal aqp-eyebrow">Every inspection, done correctly</span>
            <p className="aqp-reveal aqp-sa__lead">
              It is like having a <span>senior auditor</span> reviewing every piece of work.
              Continuously, everywhere, all the time.
            </p>
            <p className="aqp-reveal aqp-sa__body">
              Every inspection, every image, every report, and every decision is reviewed against your
              project's requirements as it comes in. We validate that the work was executed correctly and
              that every detail of everything aligns with your specifications and the applicable codes.
            </p>
            <div className="aqp-reveal aqp-sa__tags">
              <span className="aqp-sa__tag">Your specifications</span>
              <span className="aqp-sa__tag">Your procedures</span>
              <span className="aqp-sa__tag">Applicable codes</span>
            </div>
          </div>

          <div className="aqp-reveal aqp-sa__card">
            <div className="aqp-sa__card-head">
              <div className="aqp-sa__avatar" />
              <div>
                <div className="aqp-sa__card-title">Reviewing against your project</div>
                <div className="aqp-sa__card-status">
                  <span className="aqp-sa__pulse" />Calibrated to this project
                </div>
              </div>
            </div>
            <div className="aqp-sa__rows">
              {CHECKS.map((c) => (
                <div key={c.q} className="aqp-sa__row">
                  <Check />
                  <span className="aqp-sa__row-q">{c.q}</span>
                  <span className="aqp-sa__row-ref">{c.ref}</span>
                </div>
              ))}
            </div>
            <div className="aqp-sa__card-foot">
              <span>Reviewed as it comes in</span>
              <span className="aqp-sa__card-foot-em">Continuous</span>
            </div>
          </div>
        </div>

        <div className="aqp-reveal aqp-sa__callout">
          <div className="aqp-sa__callout-icon">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
            </svg>
          </div>
          <div>
            <div className="aqp-sa__callout-eyebrow">Customized with you</div>
            <p className="aqp-sa__callout-txt">
              During setup we walk you through exactly what we check, take your input, and{' '}
              <strong>add anything specific to your project</strong>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SeniorAuditor;
